import React from 'react'
import Typography from '@mui/material/Typography'

export const PropertyTitleTypography = (props) => (
  <Typography
    display="inline"
    variant="body1"
    sx={{
      color: '#8E24AA',
      cursor: 'pointer',
      fontSize: '13px',
      marginLeft: '6px',
    }}
    {...props}
  />
)
